"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ServiceNow AI Toolkit
 * ServiceNow AI Toolkit API
 *
 * The version of the OpenAPI document:
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
